module.exports = __webpack_public_path__ + "static/media/Mastericon.61dc69ed.svg";